module.exports = __webpack_public_path__ + "static/inevia-references-vrd-2b0c3e75cd6032c56284638b1a5dfc25.pdf";